import React from 'react'

export const populateCode = (code, data) =>
  Object.keys(data).reduce((acc, it) => {
    return acc.replaceAll(`{${it}}`, data[it])
  }, code)

export const useDownloadCodeblock = (
  { code, values = {} },
  filename = 'code.txt'
) => {
  const onClick = React.useCallback(() => {
    const link = document.createElement('a')
    link.href = 'data:text/html,' + encodeURIComponent(code)
    link.target = '_blank'
    link.download = filename
    link.click()
  }, [code, filename])

  return {
    ...values,
    style: { float: 'right' },
    onClick
  }
}
